'use client';

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color", "semanticColor", "paddingBottom", "variant", "className", "as"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import cx from 'classnames';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { colorClass, isSpacer, paddingBottomClass, textClass } from "../../styles/layout-theme.mjs";
export var Text = /*#__PURE__*/React.forwardRef(function TextComponent(_ref, ref) {
  var color = _ref.color,
    semanticColor = _ref.semanticColor,
    paddingBottom = _ref.paddingBottom,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'bodyMedium' : _ref$variant,
    className = _ref.className,
    as = _ref.as,
    props = _objectWithoutProperties(_ref, _excluded);
  var Element = as ? as : 'span';
  var inlineStyles = !isSpacer(paddingBottom) && {
    paddingBlockEnd: paddingBottom
  };
  return /*#__PURE__*/React.createElement(Element, Object.assign({
    className: cx('encore-text', textClass(variant), semanticColor && colorClass(semanticColor), isSpacer(paddingBottom) && paddingBottomClass(paddingBottom), className),
    ref: ref,
    "data-encore-id": ENCORE_DATA_IDS.Text,
    style: _objectSpread({}, inlineStyles)
  }, props));
});